module.exports = __webpack_public_path__ + "static/img/varios_category.d683e97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/varios_category.jpg
// module id = ntaA
// module chunks = 1